const searchInput = document.getElementById('searchInput');
const categorySelect = document.getElementById('categorySelect');
const cardList = document.getElementById('cardList');
const moreBtn = document.getElementById('moreBtn');

let filteredCards = [];
let showAll = false;

// 正規化関数（小文字化・全角半角変換）
function normalize(str) {
  return str
    .toLowerCase()
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
}

// カード表示関数
function renderCards() {
  cardList.innerHTML = "";
  const threshold = window.innerWidth <= 749 ? 16 : 24; // 749px以下は17件以上、それ以外は25件以上
  const cardsToShow = showAll ? filteredCards : filteredCards.slice(0, threshold);

  cardsToShow.forEach(card => {
    const cardEl = document.createElement('div');
    cardEl.className = 'card';
    cardEl.setAttribute('data-category', card.category);

    cardEl.innerHTML = `
      <div class="character">
        <img src="${card.image}" alt="${card.title}">
      </div>
    `;
    cardList.appendChild(cardEl);
  });

  // もっと見るボタン表示制御
  moreBtn.style.display = (filteredCards.length > threshold && !showAll) ? 'block' : 'none';
  
  // スライダーの高さを再調整（遅延実行で確実に調整）
  setTimeout(() => {
    if (typeof $ !== 'undefined' && $('#pages__books .slider.tab-slider').slick) {
      $('#pages__books .slider.tab-slider').slick('setPosition');
      // スライダーの高さを強制的に再計算
      $('#pages__books .slider.tab-slider').slick('refresh');
    }
    // 個別スライダーも再初期化
    if (typeof $ !== 'undefined' && $('#pages__books .slider-outer .slide').slick) {
      $('#pages__books .slider-outer .slide').slick('refresh');
    }
  }, 50);
}

// フィルター処理
function filterCards() {
  const keyword = normalize(searchInput.value.trim());
  const selectedCategory = categorySelect.value;

  filteredCards = cardsData.filter(card => {
    const textForSearch = normalize([card.title, card.description, ...card.keywords].join(' '));
    const matchesKeyword = !keyword || card.keywords.some(k => normalize(k).includes(keyword));
    const matchesCategory = !selectedCategory || card.category === selectedCategory;
    return matchesKeyword && matchesCategory;
  });

  showAll = false; // 再検索時にリセット
  renderCards();
}

// イベントリスナー
const searchButton = document.querySelector('#pages__books .search-box .search-button');
searchButton.addEventListener('click', filterCards);

// エンターキーでの検索機能を追加
searchInput.addEventListener('keydown', (event) => {
  if (event.key === 'Enter') {
    filterCards();
  }
});

categorySelect.addEventListener('change', filterCards);
moreBtn.addEventListener('click', () => {
  showAll = true;
  renderCards();
});

// 初期表示
filterCards();

// スライダー初期化後の高さ調整
$(document).ready(function() {
  setTimeout(() => {
    if ($('#pages__books .slider.tab-slider').slick) {
      $('#pages__books .slider.tab-slider').slick('setPosition');
      $('#pages__books .slider.tab-slider').slick('refresh');
    }
  }, 200);
});

// もっと見るボタンクリックの2秒後に高さ調整
document.getElementById("moreBtn").addEventListener("click", function() {
  setTimeout(function() {
    // 中身に合わせて slick-list の高さを更新
    $('#pages__books .slider.tab-slider').slick('setPosition');
  }, 2000); // 2秒後
});